import { executeCloudFunction } from './index';
import { getProjectErrorFromRawError, isProjectError } from '../utils/errors';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';
import { parseContents } from './utils';
import { parseLessonStatsArray } from './lessonStats/parser';
import { LessonStats } from './types/lessonStats';

export const calculateLessonStats = async () => {
  try {
    const result = await executeCloudFunction('calculateLessonStats');
    if (isProjectError(result)) {
      return getProjectErrorFromRawError(result as Error);
    }
    return result;
  } catch (error) {
    console.error('Error calculating lesson stats:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const getAllLessonStats = async (): Promise<LessonStats[]> => {
  try {
    const statsRef = collection(db, 'lessonStats');
    const q = query(statsRef, orderBy('lastUpdated', 'desc'));
    const querySnapshot = await getDocs(q);
    const rawData = parseContents(querySnapshot);

    // Add searchValue for filtering
    const dataWithSearchValue = rawData.map((item) => ({
      ...item,
      searchValue: item ? `${item.id} ${item.totalScore}` : '',
    }));

    return await parseLessonStatsArray(dataWithSearchValue);
  } catch (error) {
    console.error('[LESSON STATS] Error at getAllLessonStats:', error);
    return [];
  }
};
